import React from 'react';
import { RequireAuth } from '../utils/SessionAuthContext';

const ProtectedRoute = ({ children }) => <RequireAuth>{children}</RequireAuth>;

export default ProtectedRoute;
